export default __webpack_public_path__ + "static/usherlabs-b99520a8e404ab84e526bf8420a22fee.svg";